import { MOBEES_API_URL } from '@shared/constants/API.constants';

export const getMobeesCampaignsApiConfig = () => ({
    url: '/api/campaigns',
    method: 'GET',
    params: { excludeStatus: 'draft' },
    baseURL: MOBEES_API_URL,
});
